import { UNIVERSAL_CONST } from '@common/utils/constants';

export const LoadingText = {
  [UNIVERSAL_CONST.PAGE_LAN.CN]: '正在加载中',
  [UNIVERSAL_CONST.PAGE_LAN.TC]: '正在加載中',
  [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Loading',
};

//MARK: 首页Tab文案
export const AuthTypeTabText = {
  wx: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '微信连网',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '微信連網',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'WeChat',
  },
  sms: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '手机号连网',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '電話號連網',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Connect via SMS',
  },
  roomno: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '房间号连网',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '房間號連網',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Connect via Room No.',
  },
};

//MARK: 首页认证按钮文案
export const AuthBtnText = {
  wx: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '立即连网',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '立即連網',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'CONNECT NOW',
  },
  sms: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '获取验证码',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '獲取驗證碼',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'GET CODE',
  },
  roomno: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '立即连网',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '立即連網',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'CONNECT NOW',
  },
};

//MARK: 微信认证展示的文案
export const WxDisplayText = {
  main: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '微信授权，安全快捷',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '微信授權，安全快捷',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'WeChat Connect',
  },
  sub: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '30天享全国13000+酒店免验证上网特权',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '30天享全國13000+飯店免驗證上網特權',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Enjoy internet access up to 13000 + hotels nationwide in 30 days with Wechat verification',
  },
  warnText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '若连网后出现 “仍然通过浏览器继续操作/CONTINUE ANYWAY VIA BROWSER” 提示，请放心点击立享快速连网',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '若連網後出現“仍然通過瀏覽器繼續操作 / CONTINUE ANY VIA BROWSER”提示，請放心點擊立享快速連網',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '若连网后出现 “仍然通过浏览器继续操作/CONTINUE ANYWAY VIA BROWSER” 提示，请放心点击立享快速连网',
  },
};

export const MhomePageText = {
  'welcomeText': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '品牌欢迎您',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '品牌歡迎您',
  },
  pageTitle: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '会员上网服务',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'GO ONLINE',
  },
  inputRoomNoPlaceholder: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请输入房间门上显示的房间号',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '請輸入房間門上顯示的房間號',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Room number shown on your door',
  },
  inputLastNamePlaceholder: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请填写入住办理证件上的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '請填寫入住辦理證件上的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'First or last name',
  },
  agreementsPreText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '我已阅读并同意',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '我已閱讀並同意',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'I have read and accept the',
  },
  swxz: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '《入网须知》',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '《入網須知》',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Guest Network Guide',
  },
  end: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '《',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: ' to connect.',
  },

  phoneInputPlaceholder: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请输入您的手机号',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '請輸入您的電話號',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Enter your mobile number',
  },
  phoneErrorText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请输入正确的手机号',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '請輸入正確的電話號',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please enter the correct mobile number',
  },
  roomnoErrorText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请输入正确的房间号',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '请输入正确的房间号',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please enter the correct room number',
  },
  '300202': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请填写您办理入住时使用的证件上的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '請填寫您辦理入住時使用的證件上的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please enter your first name or last name as shown on your passport/ID used for check-in.',
  },
  '300203': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请填写您办理入住时使用的证件上的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '請填寫您辦理入住時使用的證件上的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please enter your first name or last name as shown on your passport/ID used for check-in.',
  },
  '300204': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '房间号验证失败，请核对并输入房间门上的号码或联系前台协助',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '房間號驗證失敗，請核對並輸入房間門上的號碼或聯繫前台協助',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Room number incorrect. Please verify the number on your door or contact the front desk.',
  },
  '300206': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '系统连接超时，请稍后重试',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '系統連接超時，請稍後重試',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Connection timed out. Please try again later.',
  },
  nameErrorText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请填写您办理入住时使用的证件上的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '請填寫您辦理入住時使用的證件上的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please enter your first name or last name as shown on your passport/ID used for check-in.',
  },
  smsAuthContentMainTitle: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '',
  },
  roomnoAuthContentMainTitle: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'CONNECT TO THE INTERNET BY ROOM NUMBER',
  },
  roomnoAuthTip: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '适用于持护照、港澳居民来往内地通行证、台湾居民来往大陆通行证入住的客人',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '适用于持护照、港澳居民来往内地通行证、台湾居民来往大陆通行证入住的客人',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'For guests checking in with Passport, Mainland Travel Permit for Hong Kong and Macao Residents or Mainland travel permit for Taiwan residents',
  }
};

//MARK: 验证码填写页案
export const FillSmsPageText = {
  'ConnectButton': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '立即连网',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '立即連網',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'CONNECT NOW',
  },
  'Connecting': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '连网中',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '連網中',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'CONNECTING',
  },
  'SendSms': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '验证码已发送至',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '驗證碼已發送至',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'The verification code has been sent to',
  },
  'ReSendSms': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '重新获取',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '重新獲取',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Resend',
  },
  'ReSendSmsText': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '后可重新获取',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '後可重新獲取',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Resend the verification code after',
  }
};


export const roomnoAuthPopAlert = {
  'title': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '温馨提示',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '溫馨提示',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Tips',
  },
  'content' : {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '该服务仅适用于持护照、港澳居民往来内地通行证、台湾居民往来大陆通行证办理入住登记的客人使用。除此之外的客人请尝试其他连网方式',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '該服務僅適用於持護照、港澳居民往來內地通行證、台灣居民往來大陸通行證辦理入住登記的客人使用。除此之外的客人請嘗試其他連網方式',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'This service is only available for guests who checked in with a passport, Hong Kong/Macau Resident Permit, or Taiwan Resident Permit. Other guests, please try alternative Wi-Fi options.',
  },
  'tip' : {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '',
  }

}

export const roomnoAuthMultiErrPopAlert = {
  'title': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '温馨提示',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '溫馨提示',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Tips',
  },
  'content' : {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请核对房间号及姓名（需与入住登记信息一致），如需协助请联系前台。',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '請核對房間號及姓名（需與入住登記信息一致），如需協助請聯繫前台。',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please verify your room number and name (must match your check-in details). For assistance, contact the front desk.',
  },
  'tip' : {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '提示：本服务仅适用于持护照、港澳居民往来内地通行证、台湾居民往来大陆通行证入住的客人。除此之外的客人请尝试其他连网方式',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '提示：本服務僅適用於持護照、港澳居民往來內地通行證、台灣居民往來大陸通行證入住的客人。除此之外的客人請嘗試其他連網方式',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Note: This service is only available for guests who checked in with a passport, Hong Kong/Macau Resident Permit, or Taiwan Resident Permit. Other guests, please try alternative Wi-Fi options.',
  },
}

export const AgreementPopAlert = {
  popAlertTitle: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '入网协议及隐私保护',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '入網協議及隱私保護',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Network Access Agreement',
  },

  agreementsPopAlertPreText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '为了更好地保障您的合法权益，请您阅读并同意以下协议',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '為了更好地保障您的合法權益，請您閱讀並同意以下協議',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please read and check the',
  },

  calcelBtn: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '不同意',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '不同意',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Disagree',
  },
  confirmBtn: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '同意',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '同意',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Agree',
  },
};

export const PCPageText = {
  rightsAreaTitle: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '入住期间，您可享以下温馨服务',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Get Your Benefits Now',
  },

  rightsHuazhuDesc1: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '华住会是华住集团旗下会员俱乐部，为全球超过3.0亿会员提供高效便捷的酒店线上预订服务。提供个性化搜索、在线选房、自助入住、高速wifi、发票预约等全方位的住宿体验。',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '华住会是华住集团旗下会员俱乐部，为全球超过3.0亿会员提供高效便捷的酒店线上预订服务。提供个性化搜索、在线选房、自助入住、高速wifi、发票预约等全方位的住宿体验。',
  },
  rightsHuazhuDesc2: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '华住集团旗下经营30多个酒店及公寓品牌，覆盖从豪华到经济型市场。品牌包括：施柏阁/施柏阁大观、宋品、禧玥、花间堂、美仑美奂、美仑国际、美仑、全季大观、水晶、漫心、城际、美居、诺富特、CitiGO、全季、桔子、星程、汉庭、汉庭快捷、宜必思、海友、你好、怡莱等。',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '华住集团旗下经营30多个酒店及公寓品牌，覆盖从豪华到经济型市场。品牌包括：施柏阁/施柏阁大观、宋品、禧玥、花间堂、美仑美奂、美仑国际、美仑、全季大观、水晶、漫心、城际、美居、诺富特、CitiGO、全季、桔子、星程、汉庭、汉庭快捷、宜必思、海友、你好、怡莱等。',
  },
  signAreaPhoneTitle: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '手机验证码连网',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Welcome to\nH Rewards',
  },
  signAreaRoomNoTitle: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '房间号连网',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Welcome to\nH Rewards',
  },
  inputRoomNoPlaceholder: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请输入房间门上显示的房间号',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Room number shown on your door',
  },
  inputLastNamePlaceholder: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请填写入住办理证件上的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'First or last name',
  },
  inputPhonePlaceholder: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请输入您的手机号码',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Phone Number',
  },
  inputVerificationCodePlaceholder: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请输入验证码',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'verification code',
  },
  agreementsPreText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '我已阅读并同意',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'I accept the',
  },
  swxz: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '入网须知',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Guest Network Guide',
  },
  yssm: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '华住隐私声明',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '',
  },
  hyjh: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '华住会会员计划与服务条款',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '',
  },
  rcwlhy: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '融创文旅会员协议',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '',
  },
  rcwlys: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '融创文旅隐私协议',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '',
  },
  connectBtn: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '立即连网',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'GO ONLINE',
  },
  popagreeBtn: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '同意',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Agree',
  },
  connectBtnDisagree: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '不同意',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Disagree',   
  },
  switchTextType1: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '其他连网方式',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: '其他连网方式',
  },
  switchTextType2: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '扫码连网更方便',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Scan QR code',
  },
  switchTextType3: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '扫码连网更方便',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Scan QR code',
  },
  popAlertTitle: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '入网协议',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Network Access Agreement',
  },
  popAlertRwxz: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请您阅读并同意 ',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please read and check the ',
  },
  popAlertTerms: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '《入网须知》',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '《入網須知》',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Guest Network Guide',
  },
  popAlertTermsEnd: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: ' 后继续连网',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: ' 後繼續連網',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: ' to connect',
  },
  swxzAgreeText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请您勾选入网须知后继续连网',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please accept the Guest Network Guide before proceeding.',
  },
  successText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '连网失败',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Networking failure',
  },
  successSubText: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '您可点击任务栏的WiFi按钮，选择华住WiFi，再次连网',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'You can click the WiFi button on the taskbar, select Huazhu WiFi and connect to the network again',
  },
  tabChangeText: {
    '2': {
      [UNIVERSAL_CONST.PAGE_LAN.CN]: '手机号连网',
      [UNIVERSAL_CONST.PAGE_LAN.EN]: '手机号连网',
    },
    '3': {
      [UNIVERSAL_CONST.PAGE_LAN.CN]: '房间号连网',
      [UNIVERSAL_CONST.PAGE_LAN.EN]: '房间号连网',
    },
  },
  

};

export const ToastText = {
  roomNo: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请输入正确的房间号',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please enter the correct room number',
  },
  lastName: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请输入您的姓或名',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please enter your first name or last name',
  },
  notCheckIn: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '您未入住，暂不能连网',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: "You can't connect to the Internet until you check in",
  },
  notCheckAgeements: {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '请勾选入网须知',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please accept the Guest Network Guide before proceeding.',
  },
};


export const SmsAuthText = {
  'sendSuccess': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '发送成功',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '發送成功',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Sent successfully',
  },
  'sendFaild': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '验证码发送失败',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '驗證碼發送失敗',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Verification code sending failed',
  },
  'smsStillValid': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '验证码依然有效',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '驗證碼依然有效',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'The verification code is still valid',
  },
  'phoneError': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '手机号错误',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '手機號碼錯誤',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Wrong phone number',
  },
  'smsOverTime': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '短信验证码过期',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '簡訊驗證碼過期',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'verification code expired',
  },
  'smsError': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '短信验证码错误',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '簡訊驗證碼錯誤',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'verification code error',
  },
  'smsErrHigh': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '验证码错误次数过多，请您重新获取验证码',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '驗證碼錯誤次數過多，請您重新獲取驗證碼',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Verification code errors are too high. Please obtain the verification code again',
  }

}
export const ConfirmBtnText =  {
  [UNIVERSAL_CONST.PAGE_LAN.CN]: '我知道了',
  [UNIVERSAL_CONST.PAGE_LAN.TC]: '知道了',
  [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Get it',
}
export const CommonErrorText = {
  [UNIVERSAL_CONST.PAGE_LAN.CN]: '请稍后再试',
  [UNIVERSAL_CONST.PAGE_LAN.TC]: '請稍後再試',
  [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Please try again later',
}

export const MFailPageText = {
  'failTitle': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '连网失败',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '連網失敗',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Connection Failed',
  },
  'failSubTitle': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '由于当前网络环境较慢，您可以稍后再尝试连网',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '由於當前網絡環境較慢，您可稍後再嘗試連網',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Owing to the delay of network connection, please try the WiFi connection later.',
  }
}
export const MSuccessPageText = {
  'successTitle': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '连网成功!',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '連網成功!',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Device Connected',
  },
}
export const CountryCodeText = {
  'title': {
    [UNIVERSAL_CONST.PAGE_LAN.CN]: '选择手机号归属地',
    [UNIVERSAL_CONST.PAGE_LAN.TC]: '選擇手機號碼歸屬地',
    [UNIVERSAL_CONST.PAGE_LAN.EN]: 'Select country/region',
  },
}
